/*========================================================================
* $Id$
*
* Copyright © Mindbreeze Software GmbH, Linz, Austria, 2005-2013
*
* Der Nutzer des Computerprogramms anerkennt, dass der oben stehende
* Copyright-Vermerk im Sinn des Welturheberrechtsabkommens an der vom
* Urheber festgelegten Stelle in der Funktion des Computerprogramms
* angebracht bleibt, um den Vorbehalt des Urheberrechtes genuegend zum
* Ausdruck zu bringen. Dieser Urheberrechtsvermerk darf weder vom Kunden,
* Nutzer und/oder von Dritten entfernt, veraendert oder disloziert werden.
* =========================================================================*/

define([
    "api/v2/getprofile",    
    "api/v2/search",    
    "api/v2/preview",    
    "api/v2/suggest",
    "api/v2/sourceinfo",
    "api/v2/usersourceinfo",
    "api/v2/logout",
    "api/v2/resources",
    "api/v2/export",
    "api/v2/persisted",
    "api/v2/personalization"
  ],
  function(
    GetProfile,
    Search,
    Preview,
    Suggest,
    SourceInfo,
    UserSourceInfo,
    Logout,
    Resources,
    Export,
    Persisted,
    Personalization
  ) {

    var api = {
      search: new Search.ServiceFactory(),
      preview: new Preview.ServiceFactory(),
      suggest: new Suggest.ServiceFactory(),
      sourceInfo: new SourceInfo.ServiceFactory(),
      userSourceInfo: new UserSourceInfo.ServiceFactory(),
      getProfile: new GetProfile.ServiceFactory(),
      logout: new Logout.ServiceFactory(),
      resources: new Resources.ServiceFactory(),
      exportsearch: new Export.ServiceFactory(),   
      personalization: new Personalization.ServiceFactory()   
    };

    return api;
});
